import React from 'react';
import PageLayout from 'components/layouts/PageLayout';
import { InnerSection } from 'components/layouts/CommonForm';
import { InnerGroup } from 'components/layouts/CommonForm';
import Text from 'components/commons/Text';
import InputField from 'components/input/InputField';
import ButtonWrapper from 'components/pages/listings/ButtonWrapper';
import Button from 'components/input/Button';

const WifiInfoPage = () => {
  return (
    <PageLayout title="와이파이 정보">
      <InnerSection>
        <InnerGroup>
          <div>
            <Text type="H3">와이파이 접속 정보</Text>
            <Text type="H4">와이파이 접속 정보를 입력해주세요.</Text>
          </div>
          <div>
            <InputField label="네트워크 ID" style={{ width: 265 }} />
            <InputField label="네트워크 비밀번호" style={{ width: 265, marginTop: 20 }} />
          </div>
        </InnerGroup>
      </InnerSection>
      <ButtonWrapper>
        <Button>저장</Button>
      </ButtonWrapper>
    </PageLayout>
  );
};

export default WifiInfoPage;
